import * as React from 'react';
import emailjs from '@emailjs/browser';
import ReCAPTCHA from 'react-google-recaptcha';
import { Box, Button, Container, Grid, Paper, TextField, Typography } from '@mui/material';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import CustomDivider from './CustomDivider';
import { withTranslation } from 'react-i18next';

function Contact({ t }) {
  const fieldLabelMap = { firstName: 'name', lastName: 'last name', email: 'email', organization: 'company', phoneNumber: 'phone' };
  const fields = ['firstName', 'lastName', 'email', 'organization', 'phoneNumber'];
  const [recaptchaValue, setRecaptchaValue] = React.useState(null);
  const recaptchaRef = React.useRef();

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
    if (!recaptchaValue) { alert('Please verify you are not a robot.'); return; }
    emailjs.sendForm('service_cjh18l1', 'template_1uq3xjs', form, 'sHfVVbPaModtqrACK').then(
      () => { alert('Message sent successfully!'); form.reset(); recaptchaRef.current.reset(); setRecaptchaValue(null); },
      () => alert('Failed to send message. Please try again later.')
    );
  };

  return (
    <Box sx={{ py: { xs: 7, md: 10 } }}>
      <Container maxWidth="md">
        <Box sx={{ textAlign: 'center', maxWidth: 650, mx: 'auto', mb: 5 }}>
          <Typography variant="h2">{t('Contact.title')}</Typography><CustomDivider sx={{ mx: 'auto', mt: 2 }} />
        </Box>
        <Paper elevation={0} sx={{ p: { xs: 2.5, sm: 4, md: 5 }, borderRadius: 5 }}>
          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={2.5}>
              {fields.map((field) => (
                <Grid item xs={12} sm={field === 'email' ? 12 : 6} key={field}>
                  <TextField fullWidth label={t(`Contact.${fieldLabelMap[field]}`)} name={field} type={field === 'email' ? 'email' : field === 'phoneNumber' ? 'tel' : 'text'} required={['firstName', 'lastName', 'email'].includes(field)} />
                </Grid>
              ))}
              <Grid item xs={12}><TextField fullWidth label={t('Contact.message')} name="message" required multiline minRows={6} /></Grid>
              <Grid item xs={12} sx={{ overflowX: 'auto' }}><ReCAPTCHA ref={recaptchaRef} sitekey="6Lc6OHsrAAAAAPnZcxVx7KpgqJgLqb66KJtO3yCu" onChange={setRecaptchaValue} /></Grid>
              <Grid item xs={12}><Button type="submit" variant="contained" size="large" endIcon={<SendRoundedIcon />}>{t('Contact.button')}</Button></Grid>
            </Grid>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}

export default withTranslation()(Contact);
